const HOVER_POINTER_QUERY = "(hover: hover) and (pointer: fine)";
const hoverPointerMediaQuery = window.matchMedia(HOVER_POINTER_QUERY);

function createOverlay(image) {
  const overlay = document.createElement("div");
  overlay.setAttribute("class", "image-magnify-full-size");
  overlay.setAttribute("aria-hidden", "true");
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  return overlay;
}

function getOverlay(image) {
  return (
    image.parentElement.querySelector(".image-magnify-full-size") ||
    createOverlay(image)
  );
}

function updateOverlay(image, overlay, event, zoomRatio) {
  const bounds = image.getBoundingClientRect();
  const xPosition = event.clientX - bounds.left;
  const yPosition = event.clientY - bounds.top;
  const xPercent = `${(xPosition / bounds.width) * 100}%`;
  const yPercent = `${(yPosition / bounds.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px`;
}

function showOverlay(image, overlay, event, zoomRatio) {
  if (!overlay.isConnected) {
    image.parentElement.insertBefore(overlay, image);
  }

  image.style.opacity = "0";
  updateOverlay(image, overlay, event, zoomRatio);
}

function hideOverlay(image, overlay) {
  image.style.opacity = "";
  overlay.remove();
}

function bindHoverZoom(image, zoomRatio) {
  const productInfo = image.closest("product-info[data-zoom-on-hover]");
  if (!productInfo) return;

  const opener = image.closest(".product__modal-opener");
  if (!opener) return;

  let overlay = null;

  opener.addEventListener("mouseenter", (event) => {
    if (!hoverPointerMediaQuery.matches) return;
    overlay = getOverlay(image);
    showOverlay(image, overlay, event, zoomRatio);
  });

  opener.addEventListener("mousemove", (event) => {
    if (!hoverPointerMediaQuery.matches) return;
    if (!overlay) return;
    updateOverlay(image, overlay, event, zoomRatio);
  });

  opener.addEventListener("mouseleave", () => {
    if (!overlay) return;
    hideOverlay(image, overlay);
    overlay = null;
  });
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll(".image-magnify-hover").forEach((image) => {
    if (image.dataset.zoomBound === "true") return;
    image.dataset.zoomBound = "true";
    bindHoverZoom(image, zoomRatio);
  });
}

enableZoomOnHover(2);
